import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createRootRoute, createRoute, createRouter, RouterProvider, useRouter, useRouterState } from '@tanstack/react-router';
import { V1Route } from './v1/V1Route.js';
import './workspace.css';

const element = document.getElementById('root');
if (!element) throw new Error('Calendar root element is missing.');
const root = createRoot(element);

async function start() {
  const VoiceLab = import.meta.env.DEV ? (await import('./VoiceLab.js')).VoiceLab : null;
  function ApplicationRoot() {
    const pathname = useRouterState({ select: (state) => state.location.pathname });
    const { history } = useRouter();
    if (pathname === '/voice-lab') return VoiceLab ? <VoiceLab /> : <main className="workspace-message"><h1>Voice lab is development only</h1></main>;
    return <V1Route history={history} />;
  }
  const rootRoute = createRootRoute({ component: ApplicationRoot });
  const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: '/' });
  const resetRoute = createRoute({ getParentRoute: () => rootRoute, path: '/reset-password', validateSearch: (search: Record<string, unknown>) => search });
  const voiceLabRoute = createRoute({ getParentRoute: () => rootRoute, path: '/voice-lab' });
  // Every other address is a page of the app (`/home`, `/<date>`, `/<date>/<handle>`, `/<handle>`); V1Route reads it.
  const pageRoute = createRoute({ getParentRoute: () => rootRoute, path: '$' });
  const router = createRouter({ routeTree: rootRoute.addChildren([indexRoute, resetRoute, voiceLabRoute, pageRoute]) });
  root.render(<StrictMode><RouterProvider router={router} /></StrictMode>);
}

void start().catch((error: unknown) => {
  root.render(<main className="workspace-message"><h1>Workspace could not start</h1>
    <p role="alert">{error instanceof Error ? error.message : 'Unknown startup error'}</p></main>);
});
